module.exports = __webpack_public_path__ + "static/media/Albus-Dumbledore.c54e5c28.jpg";